import type { OfflineModels } from '../offline/types'
import type { RealtimeModels } from './types'

export type Models = RealtimeModels & OfflineModels

/**
 * @brief 生成模型入口。
 * 用于按开放平台公开的模型名称创建实时或离线模型对象。
 * @notes 该入口只负责构造模型对象，不会在本地校验模型名称或账号权限。
 */
export const models: Models = {

  /**
   * @brief 选择一个实时生成模型。
   * @param name 模型的公开名称，例如 `x2.0`。
   * @returns 包含原始模型名称的 ModelDefinition。
   */
  realtime(name) {
    return { name }
  },

  /**
   * @brief 选择一个离线生成模型。
   * @param name 模型的公开名称，例如 `x2.0`。
   * @returns 包含原始模型名称的 ModelDefinition。
   */
  offline(name) {
    return { name }
  },
}
